<template>
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
  >
    <path d="M3 5V3C3 1.34315 4.34315 0 6 0C6.76836 0 7.46925 0.288856 8.00001 0.763899C8.53076 0.288855 9.23165 0 10 0C11.6569 0 13 1.34315 13 3V5H14.5C15.3284 5 16 5.67157 16 6.5V16.505C16 18.4352 14.4352 20 12.505 20H4C1.79086 20 0 18.2091 0 16V6.5C0 5.67157 0.671573 5 1.5 5H3ZM9.63496 18.5C9.24099 17.9343 9.01 17.2466 9.01 16.505V6.5H1.5V16C1.5 17.3807 2.61929 18.5 4 18.5H9.63496ZM7.5 5V3C7.5 2.17157 6.82843 1.5 6 1.5C5.17157 1.5 4.5 2.17157 4.5 3V5H7.5ZM9 5H11.5V3C11.5 2.17157 10.8284 1.5 10 1.5C9.53504 1.5 9.11949 1.71156 8.84435 2.04368C8.9453 2.34403 9 2.66563 9 3V5ZM10.51 16.505C10.51 17.6068 11.4032 18.5 12.505 18.5C13.6068 18.5 14.5 17.6068 14.5 16.505V6.5H10.51V16.505Z" />
  </svg>
</template>
